export { default } from "./ERC20Gated"
